import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './HeaderNavigation.css';
import { SupportPageItem } from '../../support/util/getSupportUrl';
import { ButtonItem } from '../components/button/Button';
import useDocumentTitle from '../hooks/title-hook';
import { HeaderNavigationTopBar } from './haderNavigationTopBar/HeaderNavigationTopBar';
import { HeaderScrollNavigationBar } from './headerScrollNavigationBar/HeaderScrollNavigationBar';
import { useHeaderNavigationState } from './useHeaderNavigationState';
import { usePageTitle } from './usePageTitle';

type HeaderNavigationProps = {
  bottomBarActionButton?: ButtonItem;
  profilePageItems?: any[];
  supportPageItems?: SupportPageItem[];
};

export function HeaderNavigation({
  bottomBarActionButton,
  profilePageItems,
  supportPageItems,
}: HeaderNavigationProps) {
  const [isBottomBarVisible, setIsBottomBarVisible] = useState(false);
  const { t } = useTranslation();

  const {
    activeNavItem,
    activeTab,
    activeItemTabs,
    isMiddleBarVisible,
    navigationLibraryItems,
    setIsMiddleBarVisible,
  } = useHeaderNavigationState(profilePageItems, supportPageItems);
  const title = usePageTitle(activeTab, activeNavItem);

  useEffect(() => {
    setIsBottomBarVisible(!!(activeItemTabs || bottomBarActionButton));
  }, [activeItemTabs, bottomBarActionButton]);

  useDocumentTitle(`${title ? `${title} - ` : ''}Champion Health`, t('page.description.loggedin'));

  return (
    <header id="header-container">
      <HeaderNavigationTopBar
        activeTabLabel={
          activeNavItem ? t(`nav.pages.${activeNavItem?.code}`) : t('nav.pages.for-you')
        }
        changeMiddleBarVisibility={() => setIsMiddleBarVisible(!isMiddleBarVisible)}
        isMiddleBarVisible={isMiddleBarVisible}
      />
      <div
        hidden={!isMiddleBarVisible}
        aria-hidden={!isMiddleBarVisible}
        id="health-areas-navigation"
        className={`middle-bar-container ${isMiddleBarVisible ? 'visible' : 'hidden'}`}
      >
        <HeaderScrollNavigationBar
          activeTab={activeNavItem}
          label={{
            id: 'health-areas-navigation',
            text: t('nav.pages.healthAreas'),
          }}
          links={navigationLibraryItems}
          changeMiddleBarVisibility={() => setIsMiddleBarVisible(false)}
        />
      </div>
      <div
        hidden={!isBottomBarVisible}
        aria-hidden={!isBottomBarVisible}
        id="bottom-bar-navigation"
        className={`bottom-bar-container ${isBottomBarVisible ? 'visible' : 'hidden'}`}
      >
        {isBottomBarVisible && (
          <HeaderScrollNavigationBar
            actionButton={bottomBarActionButton}
            activeTab={activeTab}
            label={{
              id: 'active-item-tabs',
              text: t('nav.pages.activeItemTabs'),
            }}
            links={activeItemTabs}
            healthAreaLabel={
              activeNavItem ? t(`nav.pages.${activeNavItem?.code}`) : t('nav.pages.for-you')
            }
            second
          />
        )}
      </div>
    </header>
  );
}
